import React from 'react';
import { TextField, MenuItem, Typography } from '@mui/material';
import {
  userSelectFieldStyles,
  selectPlaceholderStyles,
  noRecipientsTextStyles,
} from '../../../constants/escalateQueryDialog';

/**
 * EscalationUserSelector Component
 * Dropdown for selecting escalation user
 */
const EscalationUserSelector = ({
  selectedRole,
  selectedRoleOption,
  selectedUserId,
  errors,
  onUserChange,
}) => {
  if (!selectedRole) {
    return null;
  }

  if (!selectedRoleOption) {
    return (
      <Typography variant="caption" sx={noRecipientsTextStyles}>
        No recipients available for the selected role.
      </Typography>
    );
  }

  if (selectedRoleOption.users.length === 0) {
    return (
      <Typography variant="caption" sx={noRecipientsTextStyles}>
        No recipients available for the selected role.
      </Typography>
    );
  }

  const placeholder = `Select ${selectedRoleOption.roleLabel}`;

  return (
    <TextField
      select
      fullWidth
      value={selectedUserId}
      onChange={onUserChange}
      placeholder={placeholder}
      InputLabelProps={{ shrink: false }}
      SelectProps={{
        displayEmpty: true,
        renderValue: (selected) => {
          if (!selected) {
            return (
              <Typography component="span" sx={selectPlaceholderStyles}>
                {placeholder}
              </Typography>
            );
          }
          const selectedUser = selectedRoleOption.users.find((user) => user.id === selected);
          if (!selectedUser) {
            return selected;
          }
          return selectedUser.name;
        },
      }}
      inputProps={{
        'aria-label': placeholder,
      }}
      error={Boolean(errors.target)}
      helperText={errors.target}
      sx={userSelectFieldStyles}
    >
      {selectedRoleOption.users.map((user) => (
        <MenuItem key={user.id} value={user.id}>
          {user.name}
          {user.region && user.region !== 'ALL' ? ` • ${user.region}` : ''}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default EscalationUserSelector;
